import { ModuleConfig } from '@/core/module.ts';
import { hrRoutes } from './routes';
import { useHrEmployeeStore } from './stores/hr-employee-store';
import { useHrPayrollStore } from './stores/hr-payroll-store';
import { useHrLeaveStore } from './stores/hr-leave-store';

export const HrModule: ModuleConfig = {
  name: 'hr',
  displayName: 'Human Resources',
  description: 'Employee management, payroll, leave and attendance',
  version: '1.0.0',
  routes: hrRoutes,
  stores: {
    hrEmployee: useHrEmployeeStore,
    hrPayroll: useHrPayrollStore,
    hrLeave: useHrLeaveStore,
  },
  initialize: () => {
    // Module initialisation — can pre-warm caches here if needed
  },
};
